import { render } from "./BcMedDentalVisionTc.vue?vue&type=template&id=e9e98a9a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__